/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ScanAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function ScanAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions/ImportFromDevices/Content/ModalBody/ScanAction",
  disabled
  
}) {
let dwtOnImagesAcquireValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'onImagesAcquire',
})
let dwtIsAcquiringValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'isAcquiring',
})
let dwtIsUploadingValueData = fromData.useDataValue({ viewPath,
context: 'dwt',
path: 'isUploading',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 marginLeft={dtSpaceS}
 size="normal"
 disabled={disabled}
 data={dwtIsAcquiringValueData ? "dwt.isUploading" : "dwt.onImagesAcquire"}
 onClick={dwtOnImagesAcquireValueData}
 text={dwtIsAcquiringValueData ? "Scanning" : dwtIsUploadingValueData ? "Uploading" : "Scan"}
 data={dwtIsAcquiringValueData ? "dwt.isUploading" : "dwt.isAcquiring"}
/>
{children}
</React.Fragment>)
}